
export class CxC {
    id: number;
    fecha: string;
    valor: number;
    saldo: number;
    iva: number;
    nombres: string;
    tipoDoc: string;
    identificacion: string;
    documento: string;
    estado: string;
    numeroDocumento:string;
    factura:string;
    idCliente:number;
    idEmisor:number;
    enviado:string;
    }
    